import type { AppAbility, Subjects } from '@/shared/lib/casl'

/**
 * «Заявки на выдачу» is the station's worklist; «Ожидают подтверждения» is the
 * inbox of batches issued *to* the caller's organization — the same endpoints
 * serve a receiving institution and a receiving blood centre.
 */
export const ISSUANCE_TABS = ['applications', 'receipts'] as const

export type TIssuanceTab = (typeof ISSUANCE_TABS)[number]

const TAB_SUBJECT: Record<TIssuanceTab, Subjects> = {
  applications: 'issuance-applications',
  receipts: 'issuance-receipts',
}

/**
 * Which tabs of «Выдача» a role may open — a medical institution's warehouse
 * gets the inbox alone; the backend answers 403 on `/applications/**` (BS-295).
 */
export const getVisibleIssuanceTabs = (abilities: AppAbility) =>
  ISSUANCE_TABS.filter((tab) => abilities.can('read', TAB_SUBJECT[tab]))
